var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 5.33331H25M5 5.33331H5.01333M14.3333 18.6666H25M9 5.33331C9 7.54245 7.20914 9.33331 5 9.33331C2.79086 9.33331 1 7.54245 1 5.33331C1 3.12417 2.79086 1.33331 5 1.33331C7.20914 1.33331 9 3.12417 9 5.33331ZM9 18.6666C9 20.8758 7.20914 22.6666 5 22.6666C2.79086 22.6666 1 20.8758 1 18.6666C1 16.4575 2.79086 14.6666 5 14.6666C7.20914 14.6666 9 16.4575 9 18.6666Z",
    stroke: "#4C60E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsIcon);
export default __webpack_public_path__ + "static/media/questions_icon.ff79bb86975a76ed83c994f3c01d7d49.svg";
export { ForwardRef as ReactComponent };